import React from "react";
import Title from "../../components/Title/Title";
import { JsonLD, JsonLDData } from "react-safe-json-ld";
import { initGA, logPageView } from "../../lib/analytics";
import { Link } from "react-router-dom";

interface LayoutProps {
  title?: string;
  children: React.ReactNode;
  structuredData?: JsonLDData;
}

const Layout: React.FC<LayoutProps> = ({ title, children, structuredData }) => {
  const [isOpen, setIsOpen] = React.useState(false);

  React.useEffect(() => {
    initGA();
    logPageView(window.location.pathname);
  }, []);

  return (
    <>
      {structuredData && <JsonLD data={structuredData} />}
      <div className="min-h-screen bg-alt-wht flex flex-col">
        <Title title={title} />
        {/* Navbar */}
        <nav className="bg-alt-blk text-white py-6 sticky top-0 z-50">
          <div className="max-w-7xl mx-auto px-6">
            <div className="flex justify-between items-center">
              <div className="flex flex-row">
                <img
                  src="/images/earthboundmartian-mascot-inverted-rgb-300px-w-72ppi.png"
                  alt="Earthbound Martian"
                  className="h-14 sm:h-16 md:h-18 w-auto transition-all"
                />
                <img
                  src="/images/earthboundmartian-logotype-inverted-rgb-300px-w-72ppi.png"
                  alt="Earthbound Martian"
                  className="h-14 sm:h-16 md:h-18 w-auto transition-all"
                />
              </div>
              {/* Desktop Menu */}
              <div className="hidden md:flex space-x-8 text-lg font-large">
                <Link to="/" className="hover:text-sunset transition-colors">
                  Home
                </Link>
                <Link
                  to="/fleet"
                  className="hover:text-sunset transition-colors"
                >
                  Fleet
                </Link>
                <Link
                  to="/rentals"
                  className="hover:text-sunset transition-colors"
                >
                  Rentals
                </Link>
                <Link
                  to="/activities"
                  className="hover:text-sunset transition-colors"
                >
                  Activities
                </Link>
                <Link
                  to="/about"
                  className="hover:text-sunset transition-colors"
                >
                  About
                </Link>
                <Link
                  to="/contact"
                  className="hover:text-sunset transition-colors"
                >
                  Contact
                </Link>
              </div>

              {/* Mobile Menu Button */}
              <button
                className="md:hidden text-3xl leading-none"
                onClick={() => setIsOpen(!isOpen)}
              >
                ☰
              </button>
            </div>
            {/* Mobile Menu Dropdown */}
            {isOpen && (
              <div className="md:hidden mt-6 flex flex-col space-y-4 text-center text-lg">
                <Link to="/" className="hover:text-sunset py-2">
                  Home
                </Link>
                <Link to="/fleet" className="hover:text-sunset py-2">
                  Fleet
                </Link>
                <Link to="/rentals" className="hover:text-sunset py-2">
                  Rentals
                </Link>
                <Link to="/activities" className="hover:text-sunset py-2">
                  Activities
                </Link>
                <Link to="/about" className="hover:text-sunset py-2">
                  About
                </Link>
                <Link to="/contact" className="hover:text-sunset py-2">
                  Contact
                </Link>
              </div>
            )}
          </div>
        </nav>

        {/* Page Content */}
        <main className="flex-1 flex flex-col">{children}</main>

        {/* Footer */}
        <footer className="bg-alt-blk text-white py-12 text-sm mt-auto">
          <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-6">
            {/* CTA Button - Left */}
            <Link
              to="https://payhip.com/b/fVpO1"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-mars hover:bg-sunset text-white px-6 py-3 rounded-2xl font-semibold text-sm transition-all whitespace-nowrap"
            >
              Like this site? Buy the Template!
            </Link>

            {/* Copyright - Centered */}
            <div className="text-center">
              © 2026 Earthbound Martian, LLC • Richardson, TX
            </div>

            <Link
              to="/activities"
              className="text-ray hover:text-sunset transition-colors text-center md:text-right md:w-[200px]"
            >
              Activities &amp; Destinations
            </Link>
            <Link
              to="/consulting"
              className="text-ray hover:text-sunset transition-colors text-center md:text-right whitespace-nowrap"
            >
              Talk Shop with Chris
            </Link>
          </div>
        </footer>
      </div>
    </>
  );
};

export default Layout;
